import React from "react";
import Img from "gatsby-image";
import Helmet from "react-helmet";
import Contact from "../components/Contact";
import config from "../../data/SiteConfig";

const ContactPage = ({data}) => (
  <div>
    <Helmet title={`Contact | ${config.siteTitle}`} />
    <div className="contact-hero" />
    <div className="indexBackground">
      <div className="backgroundDarken" />
      <Img
        className="backgroundImage"
        sizes={data.backgroundImg.childImageSharp.sizes}
      />
    </div>
    <div className="hero is-medium">
      <div className="hero-body">
        <div className="container" style={{paddingTop: "38px"}}>
          <Contact />
        </div>
      </div>
    </div>
  </div>
);

export default ContactPage;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query contactQuery {
    backgroundImg: file(relativePath: { eq: "bg/contact.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 1920) {
          ...GatsbyImageSharpSizes
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/contact.jsx